import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { URL, OUTER_URL, COMPANY_NAME_KO } from '../../utils/Utils'
import Address from './Address'
import SubsidyPopup from './SubsidyPopup'
import SubsidyAgreePopup from './SubsidyAgreePopup'
import './SubsidyMain.scss'

import IMG_1_1 from 'assets/images/subsidy/two-plus-text-img.png'
import IMG_1_2 from 'assets/images/subsidy/two-plus-scooter-img.png'
import IMG_1_3 from 'assets/images/subsidy/two-plus-text-m-img.png'
import IMG_1_4 from 'assets/images/subsidy/two-plus-scooter-m-img.png'

import IMG_2_1 from 'assets/images/subsidy/utility-text-img.png'
import IMG_2_2 from 'assets/images/subsidy/utility-scooter-img.png'
import IMG_2_3 from 'assets/images/subsidy/utility-text-m-img.png'
import IMG_2_4 from 'assets/images/subsidy/utility-scooter-m-img.png'

import IMG_3_1 from 'assets/images/subsidy/subsidy-banner-pc.png'
import IMG_3_2 from 'assets/images/subsidy/subsidy-banner-mobile.png'

import IMG_4_1 from 'assets/images/subsidy/stwo-text-img.png'
import IMG_4_2 from 'assets/images/subsidy/stwo-scooter-img.png'
import IMG_4_3 from 'assets/images/subsidy/stwo-text-m-img.png'
import IMG_4_4 from 'assets/images/subsidy/stwo-scooter-m-img.png'

import {
    isOnlySpace,
    onlyNum,
    onlyKorLowEngNum,
    onlyKorEngNumSym,
    isDetailAddressInvalid,
    hyphenNumber,
    isEmailInvalid,
    isNameInvalid,
    isEmpty,
} from 'utils/UtilsFunction'

/**
 * 23.12.19 차량구매신청 외부 url 사용으로 인하여 해당 파일 close
 * @file 보조금신청 main 화면
 */
function SubsidyMain() {
    const intialValues = {
        name: '',
        email: '',
        number: '',
        auth: '',
        birth: '',
        gender: 'M',
        address: '',
        zipcode: '',
        sido: '',
        gugun: '',
        dong: '',
        detailAddress: '',
    }
    const [formValues, setFormValues] = useState(intialValues) //사용자가 입력 필드에 입력 한 데이터
    const [formErrors, setFormErrors] = useState({}) //입력 필드에 대한 오류
    const [userType, setUserType] = useState(0) //개인이용자, 사업자 여부
    const [isAuth, setIsAuth] = useState(false) //인증번호 요청 선택 시, true
    const [isAuthOk, setIsAuthOk] = useState(false) //인증번호 요청 확인 되었 을 시, true
    const [scooterData, setScooterData] = useState([]) //api 에서 가져온 스쿠터 data
    const [selectScooter, setSelectScooter] = useState({}) //스쿠터타입
    const [isSubsidy, setIsSubsidy] = useState('') //보조금 신청 여부
    const [agrees, setAgrees] = useState([false, false]) //필수 동의 여부
    const [agreesData, setAgreesData] = useState({}) //필수 api data
    const [addressShow, setAddressShow] = useState(false) // 주소검색 팝업 show
    const [popupShow, setPopupShow] = useState(false) // 팝업 show
    const [agreePopupShow, setAgreePopupShow] = useState(false) // 필수 팝업 show
    let scooterSelectRef = useRef()
    let subsidyCheckRef = useRef()
    let agreesOneCheckRef = useRef()
    let agreesTwoCheckRef = useRef()
    const location = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
        //차량 모델 data api
        axios
            .get(`${process.env.REACT_APP_BASE_URL}/v1/home/gov/bike/subsidy/search/bike`, {
                params: {
                    client_serial: 15, //닷스테이션 본사
                },
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    setScooterData(response?.data?.data)
                    setSelectScooter(response?.data?.data[0])
                } else {
                    alert(response?.data?.message)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                }
            })

        //(필수) 보조금 지원 구매 신청에 필요한 개인정보 수집·이용에 동의합니다. 의 내용 data api
        axios
            .get(`${process.env.REACT_APP_BASE_URL}/v1/home/common/recent/agreement`, {
                params: {},
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    setAgreesData(response?.data?.data[0])
                } else {
                    alert(response?.data?.message)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                }
            })
    }, [])

    //개인사업자, 법인 유무
    const userTypeOnChnage = idx => {
        setUserType(idx)
    }

    //인증 선택
    const numberOnClick = () => {
        if (isOnlySpace(formValues.name)) {
            alert('성명을 입력해 주세요')
            return
        }

        if (isOnlySpace(formValues.email) || !isEmailInvalid(formValues.email)) {
            alert('이메일을 입력해 주세요')
            return
        }

        if (isOnlySpace(formValues.number)) {
            alert('연락처를 입력해 주세요')
            return
        }

        if (!(formValues.number.length >= 10 && formValues.number.length <= 11)) {
            alert('연락처를 입력해 주세요')
            return
        }

        //인증번호 요청 api
        axios
            .post(
                `${process.env.REACT_APP_BASE_URL}/v1/user/join/auth`,
                {
                    user_tel_no: hyphenNumber(formValues.number),
                    user_name: formValues.name,
                },
                {
                    headers: {
                        'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                    },
                },
            )
            .then(response => {
                if (response?.data?.code === '00') {
                    setIsAuth(true)
                    alert('인증번호가 발송 되었습니다')
                } else {
                    alert(response?.data?.message)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                }
            })
    }

    //인증번호 확인 시
    const authOnClick = () => {
        if (!isAuth) {
            alert('성명과 연락처를 입력해 주세요')
            return
        }

        if (formValues.auth.length !== 4) {
            alert('인증번호 4자리 입력해 주세요')
            return
        }

        //인증번호 확인 api
        axios
            .post(
                `${process.env.REACT_APP_BASE_URL}/v1/user/join/auth/check`,
                {
                    access_code: formValues.auth,
                    user_tel_no: hyphenNumber(formValues.number),
                    user_name: formValues.name,
                },
                {
                    headers: {
                        'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                    },
                },
            )
            .then(response => {
                if (response?.data?.code === '00') {
                    setIsAuthOk(true)
                    alert('인증번호 확인되었습니다')
                } else {
                    alert(response?.data?.message)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                }
            })
    }

    //성별 선택 시
    const onClickGender = val => {
        setFormValues({ ...formValues, gender: val })
    }

    //입력이 formValues상태와 동기화 된 상태로 유지되고 사용자가 입력 할 때 상태가 업데이트됩니다.
    const handleChange = e => {
        const { name, value } = e.target
        let text = value

        if (name === 'all' || name === 'name') {
            const maxLen = 50

            if (value.length > maxLen) {
                return
            } else {
                text = onlyKorLowEngNum(value)
            }
        }

        if (name === 'all' || name === 'email') {
            text = value
        }

        if (name === 'all' || name === 'number') {
            const maxLen = 11

            if (value.length > maxLen) {
                return
            } else {
                text = onlyNum(value)
            }
        }

        if (name === 'all' || name === 'auth') {
            const maxLen = 4

            if (value.length > maxLen) {
                return
            } else {
                text = onlyNum(value)
            }
        }

        if (name === 'all' || name === 'birth') {
            //생년월일 or 사업자번호
            const maxLen = 10

            if (value.length > maxLen) {
                return
            } else {
                text = onlyNum(value)
            }
        }

        if (name === 'all' || name === 'detailAddress') {
            const maxLen = 50

            if (value.length > maxLen) {
                return
            } else {
                text = onlyKorEngNumSym(value)
            }
        }

        setFormValues({ ...formValues, [name]: text })
        setFormErrors(validate({ ...formValues, [name]: text }, name))
    }

    //formValues 객체를 이 함수에 대한 인수로 전달한 다음 이메일과 이름, 비밀번호를 유효성 검사 테스트 하면서 오류가 채워지고 반환됩니다.
    const validate = (values, name) => {
        let errors = { ...formErrors }

        if (name === 'all' || name === 'name') {
            if (!isNameInvalid(values.name)) {
                errors.name = ''
            } else if (isNameInvalid(values.name)) {
                delete errors.name
            }
        }

        if (name === 'all' || name === 'email') {
            if (!isEmailInvalid(values.email)) {
                errors.email = '50자 이내로 입력해주세요'
            } else if (isEmailInvalid(values.email)) {
                delete errors.email
            }
        }

        if (name === 'all' || name === 'auth') {
            if (values.auth.length === 0) {
                errors.auth = '인증번호를 입력해주세요'
            } else {
                delete errors.auth
            }
        }

        if (name === 'all' || name === 'detailAddress') {
            if (!isDetailAddressInvalid(values.detailAddress)) {
                errors.detailAddress = '50자 이내로 입력해주세요'
            } else if (isDetailAddressInvalid(values.detailAddress)) {
                delete errors.detailAddress
            }
        }

        return errors
    }

    //필수 동의 체크 여부
    const agreeOnChange = idx => {
        agrees[idx] = !agrees[idx]
        setAgrees([...agrees])
    }

    //차량 구매 신청하기 버튼 사용 가능 여부
    const isAbleBtn = isPopup => {
        //성명
        if (isOnlySpace(formValues.name) || formErrors.name) {
            if (isPopup) {
                alert('성명을 입력해 주세요')
            }
            return false
        }

        //이메일
        if (isOnlySpace(formValues.email) || formErrors.email) {
            if (isPopup) {
                alert('이메일을 입력해 주세요')
            }
            return false
        }

        //연락처
        if (isOnlySpace(formValues.number) || formErrors.number) {
            if (isPopup) {
                alert('연락처 입력해 주세요')
            }
            return false
        }

        //인증번호 선택 여부
        if (!isAuth) {
            if (isPopup) {
                alert('인증 버튼을 선택해 주세요')
            }
            return false
        }

        //인증번호 확인 여부
        if (!isAuthOk) {
            if (isPopup) {
                alert('인증번호를 확인해 주세요')
            }
            return false
        }

        //생년월일
        if (isOnlySpace(formValues.birth) || formErrors.birth) {
            if (isPopup) {
                alert('생년월일 (사업자등록번호)를 입력해 주세요')
            }
            return false
        }

        //주소
        if (isOnlySpace(formValues.address) || formErrors.address) {
            if (isPopup) {
                alert('주소를 입력해 주세요')
            }
            return false
        }

        //보조금신청희망 여부
        if (isEmpty(isSubsidy)) {
            if (isPopup) {
                alert('보조금 신청을 희망하십니까 항목 체크 확인해 주세요')
            }
            return false
        }

        if (!agrees[0]) {
            //필수1 미동의
            if (isPopup) {
                alert('필수체크를 확인해 주세요')
            }
            return false
        }
        if (!agrees[1]) {
            //필수2 미동의
            if (isPopup) {
                alert('필수체크를 확인해 주세요')
            }
            return false
        }

        return true
    }

    //구매신청 버튼 선택 시
    const btnClick = () => {
        if (!isAbleBtn(true)) {
            return
        }

        let obj = {
            order_name: formValues.name, //[필수] 신청자 이름
            order_telno: hyphenNumber(formValues.number), //[필수] 신청자 전화번호
            order_mail: formValues?.email, // [필수] 신청자 메일
            order_zipcode: formValues?.zipcode, //[필수] 신청자 우편번호
            order_sido: formValues?.sido, //[필수] 시도
            order_gugun: formValues?.gugun, //[필수] 구
            order_dong: formValues?.dong, //[필수] 동
            order_address: formValues?.detailAddress, //[필수] 세부주소
            bike_serial: selectScooter?.SERIAL_NUMBER, //[필수] 차량 고유식별번호
            bike_make: selectScooter?.BIKE_MAKE, //[필수] 제조사코드
            bike_type: selectScooter?.BIKE_TYPE, //[필수] 차종코드
            gender: formValues?.gender, // 성별
            gen_client_serial: 15, //[고정] 젠본사
            subsidy_bit: isSubsidy, //보조금신청여부
        }

        if (userType === 0) {
            //개인
            obj.birth_date = formValues?.birth //생년월일
        } else if (userType === 1) {
            //사업자(법인)
            obj.corp_ssn = formValues?.birth //사업자번호
        }

        //시승행사 params
        {
            /* 23.10.23 시승행사 end */
        }
        // if (location?.pathname === URL.SUBSIDY.DIFA2023) {
        //     obj.riding_event_bit = 'Y' //시승행사 여부
        // }

        //보조금 신청 api
        axios
            .post(`${process.env.REACT_APP_BASE_URL}/v1/home/gov/bike/subsidy/order`, obj, {
                headers: {
                    'gen-api-key': 'genstation_weIOLf2ghuRDb2dtQ1dsWGVu==',
                },
            })
            .then(response => {
                if (response?.data?.code === '00') {
                    setPopupShow(true)
                } else {
                    alert(response?.data?.message)
                }
            })
            .catch(error => {
                if (error && error.response && error.response.status) {
                    alert(`${error.response.status} error`)
                }
            })
    }

    return (
        <>
            <div className="subsidy-wrapper">
                <div className="subsidy-one">
                    <div className="subsidy-one-title">
                        친환경 시대의 첫 여정을
                        <br />
                        {COMPANY_NAME_KO}과 함께 시작하세요.
                    </div>
                    <div className="subsidy-one-scooter-info-wrapper">
                        <div className="subsidy-one-scooter-info-wrap">
                            <div className="subsidy-one-scooter-info-content">
                                <img
                                    src={IMG_4_1}
                                    className="subsidy-one-scooter-info-content-scooter-titleImg titleImg_s2 pc"
                                    alt="gogoro S2 ABS"
                                />
                                <img
                                    src={IMG_4_3}
                                    className="subsidy-one-scooter-info-content-scooter-titleImg titleImg_s2 mobile"
                                    alt="gogoro S2 ABS"
                                />
                                <img
                                    src={IMG_4_2}
                                    className="subsidy-one-scooter-info-content-scooter-scooterImg pc"
                                    alt="gogoro S2 ABS 스쿠터 이미지"
                                />
                                <img
                                    src={IMG_4_4}
                                    className="subsidy-one-scooter-info-content-scooter-scooterImg mobile"
                                    alt="gogoro S2 ABS 스쿠터 이미지"
                                />
                                <div className="subsidy-one-scooter-info-content-scooter-title">Gogoro 2 Series</div>
                                <div className="subsidy-one-scooter-info-content-scooter-desc">
                                    한계를 뛰어넘는 특별함
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price">
                                        소비자가
                                        <p className="price">￦ 6,490,000</p>
                                    </div>
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price">
                                        보조금 (23년도 기준)
                                        <p className="price">￦ 1,040,000</p>
                                    </div>
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap totla_price_wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price color_blue">
                                        자부담금
                                        <p className="price totla_price">￦ 5,450,000</p>
                                    </div>
                                    <a
                                        className="subsidy-one-scooter-info-content-scooter-bottom-more"
                                        href={URL.SCOOTER.S2}>
                                        {'차량 알아보기   >'}
                                    </a>
                                </div>
                            </div>
                            <div className="subsidy-one-scooter-info-content">
                                <img
                                    src={IMG_1_1}
                                    className="subsidy-one-scooter-info-content-scooter-titleImg pc"
                                    alt="gogoro S2 Plus"
                                />
                                <img
                                    src={IMG_1_3}
                                    className="subsidy-one-scooter-info-content-scooter-titleImg mobile"
                                    alt="gogoro S2 Plus"
                                />
                                <img
                                    src={IMG_1_2}
                                    className="subsidy-one-scooter-info-content-scooter-scooterImg scooterImg_2plus pc"
                                    alt="gogoro S2 Plus 스쿠터 이미지"
                                />
                                <img
                                    src={IMG_1_4}
                                    className="subsidy-one-scooter-info-content-scooter-scooterImg scooterImg_2plus mobile"
                                    alt="gogoro S2 Plus 스쿠터 이미지"
                                />
                                <div className="subsidy-one-scooter-info-content-scooter-title">Gogoro 2 Series</div>
                                <div className="subsidy-one-scooter-info-content-scooter-desc">
                                    모던한 라이딩의 새로운 기준
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price">
                                        소비자가
                                        <p className="price">￦ 5,790,000</p>
                                    </div>
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price">
                                        보조금 (23년도 기준)
                                        <p className="price">￦ 1,120,000</p>
                                    </div>
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap totla_price_wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price color_blue">
                                        자부담금
                                        <p className="price totla_price">￦ 4,670,000</p>
                                    </div>
                                    <a
                                        className="subsidy-one-scooter-info-content-scooter-bottom-more"
                                        href={URL.SCOOTER.PLUS}>
                                        {'차량 알아보기   >'}
                                    </a>
                                </div>
                            </div>
                            <div className="subsidy-one-scooter-info-content">
                                <img
                                    src={IMG_2_1}
                                    className="subsidy-one-scooter-info-content-scooter-titleImg pc"
                                    alt="gogoro S2 Utility"
                                />
                                <img
                                    src={IMG_2_3}
                                    className="subsidy-one-scooter-info-content-scooter-titleImg mobile"
                                    alt="gogoro S2 Utility"
                                />
                                <img
                                    src={IMG_2_2}
                                    className="subsidy-one-scooter-info-content-scooter-scooterImg scooterImg_2utility pc"
                                    alt="gogoro S2 Utility 스쿠터 이미지"
                                />
                                <img
                                    src={IMG_2_4}
                                    className="subsidy-one-scooter-info-content-scooter-scooterImg scooterImg_2utility mobile"
                                    alt="gogoro S2 Utility 스쿠터 이미지"
                                />
                                <div className="subsidy-one-scooter-info-content-scooter-title">Gogoro 2 Series</div>
                                <div className="subsidy-one-scooter-info-content-scooter-desc">
                                    비즈니스를 위한 이동수단
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price">
                                        소비자가
                                        <p className="price">￦ 5,490,000</p>
                                    </div>
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price">
                                        보조금 (23년도 기준)
                                        <p className="price">￦ 1,030,000</p>
                                    </div>
                                </div>
                                <div className="subsidy-one-scooter-info-content-scooter-bottom-wrap totla_price_wrap">
                                    <div className="subsidy-one-scooter-info-content-scooter-bottom-price color_blue">
                                        자부담금
                                        <p className="price totla_price">￦ 4,460,000</p>
                                    </div>
                                    <a
                                        className="subsidy-one-scooter-info-content-scooter-bottom-more"
                                        href={URL.SCOOTER.UTILITY}>
                                        {'차량 알아보기   >'}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="subsidy-banner pc"
                        style={{ backgroundImage: `url(${IMG_3_1})` }}
                        onClick={() => window.open(OUTER_URL.SUSIDY)}></div>
                    <div
                        className="subsidy-banner mobile"
                        style={{ backgroundImage: `url(${IMG_3_2})` }}
                        onClick={() => window.open(OUTER_URL.SUSIDY)}></div>
                </div>
                <div className="subsidy-two">
                    <div className="subsidy-two-title">
                        Gogoro 전기스쿠터 <br />
                        구매신청 하기
                    </div>
                    <div className="subsidy-two-register-box">
                        <div className="subsidy-two-register-line-one">
                            <div className="subsidy-two-register-line-one-row">
                                <label
                                    htmlFor={'general'}
                                    className={'radio-label ' + (userType === 0 ? 'select' : '')}>
                                    <input
                                        className="radio-input"
                                        type="radio"
                                        name={'general'}
                                        id={'general'}
                                        onChange={() => userTypeOnChnage(0)}
                                        checked={userType === 0}
                                    />
                                    <span className="custom-radio" />
                                    <span className={'custom-radio-text ' + (userType === 0 ? 'select' : '')}>
                                        개인 이용자
                                    </span>
                                </label>
                            </div>
                            <div className="subsidy-two-register-line-one-row">
                                <label
                                    htmlFor={'business'}
                                    className={'radio-label ' + (userType === 1 ? 'select' : '')}>
                                    <input
                                        className="radio-input"
                                        type="radio"
                                        name={'business'}
                                        id={'business'}
                                        onChange={() => userTypeOnChnage(1)}
                                        checked={userType === 1}
                                    />
                                    <span className="custom-radio" />
                                    <span className={'custom-radio-text ' + (userType === 1 ? 'select' : '')}>
                                        사업자 (법인)
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div className="subsidy-two-register-line-one">
                            <div className="subsidy-two-register-line-one-row">
                                <div className="subsidy-two-register-line-one-vertical-title">성명 (회사명)</div>
                                <input
                                    className="subsidy-two-register-line-one-vertical-input no-btn"
                                    placeholder="이름"
                                    type="text"
                                    name="name"
                                    id="name"
                                    value={formValues.name}
                                    onChange={handleChange}
                                    readOnly={isAuth}></input>
                            </div>
                            <div className="subsidy-two-register-line-one-row">
                                <div className="subsidy-two-register-line-one-vertical-title">이메일</div>
                                <input
                                    className="subsidy-two-register-line-one-vertical-input no-btn"
                                    type="text"
                                    name="email"
                                    id="email"
                                    value={formValues.email}
                                    onChange={handleChange}
                                    readOnly={isAuth}></input>
                            </div>
                        </div>

                        <div className="subsidy-two-register-line-one">
                            <div className="subsidy-two-register-line-one-row">
                                <div className="subsidy-two-register-line-one-vertical-title">연락처</div>
                                <div className="subsidy-two-register-line-one-vertical-input-box">
                                    <input
                                        className="subsidy-two-register-line-one-vertical-input"
                                        placeholder="-없이 번호 입력"
                                        type="text"
                                        name="number"
                                        id="number"
                                        value={formValues.number}
                                        onChange={handleChange}
                                        readOnly={isAuth}></input>
                                    <span
                                        className="subsidy-two-register-line-one-vertical-btn"
                                        onClick={() => numberOnClick()}>
                                        인증
                                    </span>
                                </div>
                            </div>
                            <div className="subsidy-two-register-line-one-row">
                                <div className="subsidy-two-register-line-one-vertical-title">인증번호</div>
                                <div className="subsidy-two-register-line-one-vertical-input-box">
                                    <input
                                        className="subsidy-two-register-line-one-vertical-input"
                                        placeholder=""
                                        type="text"
                                        name="auth"
                                        id="auth"
                                        value={formValues.auth}
                                        onChange={handleChange}
                                        readOnly={isAuthOk}></input>
                                    <span
                                        className="subsidy-two-register-line-one-vertical-btn"
                                        onClick={() => authOnClick()}>
                                        확인
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="subsidy-two-register-line-one row-3">
                            <div className="subsidy-two-register-line-one-row row-3">
                                <div className="subsidy-two-register-line-one-vertical-title">
                                    생년월일 (사업자등록번호)
                                </div>
                                <input
                                    className="subsidy-two-register-line-one-vertical-input no-btn"
                                    placeholder="8자리 ex) 19800505"
                                    type="text"
                                    name="birth"
                                    id="birth"
                                    value={formValues.birth}
                                    onChange={handleChange}></input>
                            </div>
                            <div className="subsidy-two-register-line-one-row row-3 gender-box">
                                <div className="subsidy-two-register-line-one-vertical-title no-title"></div>
                                <div className="subsidy-two-register-line-one-vertical gender-box">
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        className={formValues.gender === 'M' ? 'gender-select' : ''}
                                        onClick={() => onClickGender('M')}>
                                        남
                                    </span>
                                    <span className="">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        className={formValues.gender === 'F' ? 'gender-select' : ''}
                                        onClick={() => onClickGender('F')}>
                                        여
                                    </span>
                                </div>
                            </div>
                            <div className="subsidy-two-register-line-one-row row-3">
                                <div className="subsidy-two-register-line-one-vertical-title">차량 모델 선택</div>
                                <div>
                                    <select
                                        className="subsidy-two-register-line-one-vertical-input select-box"
                                        onChange={e => setSelectScooter(scooterData[e.target.selectedIndex])}
                                        ref={scooterSelectRef}>
                                        {scooterData.length > 0 &&
                                            scooterData?.map(i => (
                                                <option value={i.BIKE_TYPE_NM} key={`${i.BIKE_TYPE}`}>
                                                    {i.BIKE_TYPE_NM}
                                                </option>
                                            ))}
                                    </select>
                                    <i className="arrow down"></i>
                                </div>
                            </div>
                        </div>

                        <div className="subsidy-two-register-line-one">
                            <div className="subsidy-two-register-line-one-row">
                                <div className="subsidy-two-register-line-one-vertical-title">주소</div>
                                <div className="subsidy-two-register-line-one-vertical-input-box">
                                    <div
                                        className="subsidy-two-register-line-one-vertical-input div-btn"
                                        onClick={() => setAddressShow(true)}>
                                        {formValues?.zipcode}
                                    </div>
                                    <span
                                        className="subsidy-two-register-line-one-vertical-btn"
                                        onClick={() => setAddressShow(true)}>
                                        {isEmpty(formValues?.zipcode) ? '우편번호 검색' : ''}
                                    </span>
                                </div>
                            </div>
                            <div className="subsidy-two-register-line-one-row flex-2">
                                <div className="subsidy-two-register-line-one-vertical-title no-title"></div>
                                <input
                                    className="subsidy-two-register-line-one-vertical-input no-btn"
                                    /* onClick={() => setAddressShow(true)} */
                                    value={formValues?.address}
                                    readOnly></input>
                            </div>
                        </div>

                        <div className="subsidy-two-register-line-one hg-56">
                            <div className="subsidy-two-register-line-one-row">
                                <div className="subsidy-two-register-line-one-row">
                                    <input
                                        className="subsidy-two-register-line-one-vertical-input no-btn"
                                        placeholder="상세 주소 입력"
                                        type="text"
                                        name="detailAddress"
                                        id="detailAddress"
                                        value={formValues.detailAddress}
                                        onChange={handleChange}></input>
                                </div>
                            </div>
                        </div>

                        <div className="subsidy-two-register-line-two">
                            <div className="subsidy-two-register-line-two-box vertical">
                                <div className="subsidy-two-register-line-two-title-checkbox">
                                    보조금 신청을 희망하십니까?
                                </div>
                                <div>
                                    <span
                                        className="subsidy-two-register-line-two-text-checkbox"
                                        onClick={() => setIsSubsidy('Y')}>
                                        예
                                    </span>
                                    <input
                                        className="subsidy-two-register-line-two-checkbox"
                                        type="checkbox"
                                        onChange={() => setIsSubsidy('Y')}
                                        checked={isSubsidy === 'Y'}
                                        ref={subsidyCheckRef}></input>
                                    <span
                                        className="subsidy-two-register-line-two-text-checkbox"
                                        onClick={() => setIsSubsidy('N')}>
                                        아니오
                                    </span>
                                    <input
                                        className="subsidy-two-register-line-two-checkbox"
                                        type="checkbox"
                                        onChange={() => setIsSubsidy('N')}
                                        checked={isSubsidy === 'N'}
                                        ref={subsidyCheckRef}></input>
                                </div>
                            </div>
                            <div className="subsidy-two-register-line-two-box">
                                <div>
                                    <input
                                        className="subsidy-two-register-line-two-checkbox"
                                        type="checkbox"
                                        onChange={() => agreeOnChange(0)}
                                        checked={agrees[0]}></input>
                                </div>
                                <span
                                    className="subsidy-two-register-line-two-text"
                                    onClick={() => /* agreeOnChange(0) */ setAgreePopupShow(true)}
                                    ref={agreesOneCheckRef}>
                                    (필수) 보조금 지원 구매 신청에 필요한 개인정보 수집·이용에 동의합니다.
                                </span>
                            </div>
                            <div className="subsidy-two-register-line-two-box">
                                <div>
                                    <input
                                        className="subsidy-two-register-line-two-checkbox"
                                        type="checkbox"
                                        onChange={() => agreeOnChange(1)}
                                        checked={agrees[1]}></input>
                                </div>
                                <span
                                    className="subsidy-two-register-line-two-text"
                                    onClick={() => agreeOnChange(1)}
                                    ref={agreesTwoCheckRef}>
                                    (필수) 현재 스테이션 설치 및 운영 중인 곳 이외의 지역에서는 서비스 이용이 제한될 수
                                    있습니다.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="subsidy-three">
                    <div className="subsidy-three-title">
                        차량 구매 시<br />
                        주의 사항
                    </div>
                    <div className="subsidy-three-text">
                        · 현재 사전 구매 신청으로 판매되는 모델은 배터리 공유형 모델로서 스왑스테이션을 통해서만 이용이
                        가능하니 구매 전 참고 부탁드립니다.
                        <br />
                        &nbsp;&nbsp;* 가정용 충전 불가
                        <br />
                        <br />
                        · 정부(지자체)보조금 지급 진행 시 원활한 진행을 위하여 계약자 실거주지가 아닌 등본상 주소지를
                        입력해주세요.
                        <br />
                        <br />· 보조금에 선정되어 구매하시는 경우, 구매 가능 수량은 지자체별 상이하며, 보조금 편성에
                        따라 변동 및 취소 될 수 있습니다.
                        <br />
                        <br />· 보조금은 대상자 선정 결과에 따라 지급 되지 않을 수 있습니다.
                        <br />
                        <br />· 보조금 지급을 위해 요금제 계약을 1년 이상 유지하여야 합니다.
                    </div>
                </div>
                <div className="subsidy-four">
                    <div className="subsidy-four-title">차량 구매 신청 안내</div>
                    <div className="subsidy-four-text">
                        1. 사전 예약 후, 유선 안내 (차량 및 정부 보조금 신청 절차 안내)
                        <br />
                        <br />
                        2. 보조금 신청 (작성서류 3개)
                        <br />
                        &nbsp;&nbsp;- 구매계약서 1부 / 보조금 신청서 1부 / 개인(등본), 사업자(사업자등록증) 1부
                        <br />
                        <br />
                        3. 보조금 선정 확정 후 별도 구매 안내
                        <br />
                        <br />
                        4. 이륜차 인도 (보조금 선정 후 차량 인도)
                    </div>
                </div>
                <div className="subsidy-two-register-line-three">
                    <button className={isAbleBtn(false) ? 'button-able' : 'button-disable'} onClick={() => btnClick()}>
                        차량 구매 신청하기
                    </button>
                </div>
            </div>
            {addressShow && (
                <Address
                    addressShow={addressShow}
                    setAddressShow={setAddressShow}
                    formValues={formValues}
                    setFormValues={setFormValues}
                />
            )}
            {agreePopupShow && (
                <SubsidyAgreePopup
                    setPopupShow={setAgreePopupShow}
                    title="(필수) 보조금 지원 구매 신청에 필요한<br/>개인정보 수집·이용에 동의합니다."
                    contents={isEmpty(agreesData?.TEXT_CONTENT) ? '' : agreesData?.TAG_CONTENT}
                    callback={() => {
                        agrees[0] = true
                        setAgrees([...agrees])
                    }}
                />
            )}
            {popupShow && (
                <SubsidyPopup
                    setPopupShow={setPopupShow}
                    title="차량 구매 신청이 완료되었습니다."
                    contents="별도의 해피콜을 통해 안내드리도록 하겠습니다."
                    callback={() => {
                        window.location.reload()
                    }}
                />
            )}
        </>
    )
}

export default SubsidyMain
